import { List, Drawer } from 'antd';
import styled from 'styled-components';

export const IconWrapper = styled.div`
  display: inline-block;
  padding: 0 0.5rem 0 0.5rem;
  display: flex;
  height: 25px;
  background-color: #35b31c;
  border: 1px solid #269310;
  align-items: center;
  cursor: pointer;
  color: #fff;
  &:hover {
    background-color: #2168ff;
  }
`;


export const StyledList = styled(List)`
  .ant-list-item {
    .ant-list-item-meta {
      h4.ant-list-item-meta-title {
        color: #0046ff;
      }
    }
    &:hover {
      background-color: #e9f3fd;
    }
  }
`;


export const StyledDrawer = styled(Drawer)`
  .ant-drawer-header-title {
    flex-direction: row-reverse;
    align-items: baseline;
  }
`;
